import { getIn, useFormikContext } from 'formik';
import { InputType } from '../../../utils/@globalTypes';
import { priceMask } from '../../../utils/constants';
import Input from '../../Input';
import styles from './ObjectPriceSample.module.scss';
import { PriceFormType } from '../../../redux/types/pricesTypes';

type ObjectPriceSampleType = {
  title?: string;
  itemName: ObjectPriceKeys;
};
type ObjectPriceKeys =
  | 'base_price'
  | 'extra_guest_price'
  | `kidsPrice[${number}].price`;

const ObjectPriceSample = ({ title, itemName }: ObjectPriceSampleType) => {
  const { handleChange, values, setFieldTouched, touched, errors } =
    useFormikContext<PriceFormType>();

  const weekdayValue = getIn(values, `${itemName}.high_season_weekday_price`);
  const weekdayError = getIn(errors, `${itemName}.high_season_weekday_price`);
  const weekdayTouched = getIn(
    touched,
    `${itemName}.high_season_weekday_price`,
  );

  const weekendValue = getIn(values, `${itemName}.high_season_weekend_price`);
  const weekendError = getIn(errors, `${itemName}.high_season_weekend_price`);
  const weekendTouched = getIn(
    touched,
    `${itemName}.high_season_weekend_price`,
  );

  const low_weekdayValue = getIn(
    values,
    `${itemName}.low_season_weekday_price`,
  );
  const low_weekdayError = getIn(
    errors,
    `${itemName}.low_season_weekday_price`,
  );
  const low_weekdayTouched = getIn(
    touched,
    `${itemName}.low_season_weekday_price`,
  );

  const low_weekendValue = getIn(
    values,
    `${itemName}.low_season_weekend_price`,
  );
  const low_weekendError = getIn(
    errors,
    `${itemName}.low_season_weekend_price`,
  );
  const low_weekendTouched = getIn(
    touched,
    `${itemName}.low_season_weekend_price`,
  );
  // priceMask.max=9999.99

  return (
    <div className={styles.container}>
      {title && <h3 className={styles.title}>{title}</h3>}
      <div className={styles.wrap}>
        <div className={styles.column}>
          <h4 className={styles.contentTitle}>Высокий сезон</h4>
          <div className={styles.price_block}>
            <Input
              id={`${itemName}.high_season_weekday_price`}
              name={`${itemName}.high_season_weekday_price`}
              value={weekdayValue}
              title="Будние дни*"
              placeholder="0.00"
              type={InputType.MASK}
              onChange={handleChange(`${itemName}.high_season_weekday_price`)}
              errText={weekdayTouched && weekdayError}
              onBlur={() =>
                setFieldTouched(`${itemName}.high_season_weekday_price`)
              }
              containerClassName="price"
              mask={priceMask}
            />
            <Input
              id={`${itemName}.high_season_weekend_price`}
              name={`${itemName}.high_season_weekend_price`}
              value={weekendValue}
              title="Выходные дни*"
              placeholder="0.00"
              type={InputType.MASK}
              onChange={handleChange(`${itemName}.high_season_weekend_price`)}
              errText={weekendTouched && weekendError}
              onBlur={() =>
                setFieldTouched(`${itemName}.high_season_weekend_price`)
              }
              containerClassName="price"
              mask={priceMask}
            />
          </div>
        </div>
        <div className={styles.column}>
          <h3 className={styles.contentTitle}>Низкий сезон</h3>
          <div className={styles.price_block}>
            <Input
              id={`${itemName}.low_season_weekday_price`}
              name={`${itemName}.low_season_weekday_price`}
              value={low_weekdayValue}
              title="Будние дни*"
              placeholder="0.00"
              type={InputType.MASK}
              onChange={handleChange(`${itemName}.low_season_weekday_price`)}
              errText={low_weekdayTouched && low_weekdayError}
              onBlur={() =>
                setFieldTouched(`${itemName}.low_season_weekday_price`)
              }
              containerClassName="price"
              mask={priceMask}
            />
            <Input
              id={`${itemName}.low_season_weekend_price`}
              name={`${itemName}.low_season_weekend_price`}
              value={low_weekendValue}
              title="Выходные дни*"
              placeholder="0.00"
              type={InputType.MASK}
              onChange={handleChange(`${itemName}.low_season_weekend_price`)}
              errText={low_weekendTouched && low_weekendError}
              onBlur={() =>
                setFieldTouched(`${itemName}.low_season_weekend_price`)
              }
              containerClassName="price"
              mask={priceMask}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ObjectPriceSample;
